// extracted by css-extract-rspack-plugin
module.exports =  {"formSection":"FormSection__formSection--Cckf7"};